import { render } from "./Shell.vue?vue&type=template&id=438065cc&scoped=true"
import script from "./Shell.vue?vue&type=script&lang=js"
export * from "./Shell.vue?vue&type=script&lang=js"

import "./Shell.vue?vue&type=style&index=0&id=438065cc&scoped=true&lang=css"

import exportComponent from "/build/webui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-438065cc"]])

export default __exports__